
import httpclient from 'libs/Axios';
import { openWindow } from 'core/utils/constants';
import { SOOMUCH_BASE_URL } from 'core/utils/constants/ApiConstants';
import { useWhatsAppAuth } from './useWhatsAppAuth';

const getCurrentOrigin = () => {
    const currentOrigin = window.location.origin;

    if (currentOrigin) {
        return currentOrigin;
    }

    return SOOMUCH_BASE_URL;
};

const getMetaRedirectUri = () => {
    return `${getCurrentOrigin()}/meta_auth`;
};

const getGoogleAuthUrl = (authUrl?: string) => {
    if (!authUrl) {
        return authUrl;
    }

    try {
        const url = new URL(authUrl);

        if (url.searchParams.has('redirect_uri')) {
            url.searchParams.set('redirect_uri', `${getCurrentOrigin()}/google`);
        }

        return url.toString();
    } catch (err) {
        return authUrl;
    }
};

export const useSocialAuth = (selectedSocialMedia: any) => {
    const { handleWhatsAppAuthFlow, whatsAppSession } = useWhatsAppAuth();

    const openPopUp = (socialMedia?) => {
        const redirectUri = encodeURIComponent(getMetaRedirectUri());
        const instagramURL = `https://www.instagram.com/oauth/authorize?force_reauth=true&client_id=1117846696952857&redirect_uri=${redirectUri}&response_type=code&scope=instagram_business_basic,instagram_business_content_publish`;
        const facebookUrl = `https://www.facebook.com/v19.0/dialog/oauth?client_id=798892955436817&redirect_uri=${redirectUri}&response_type=token&scope=pages_manage_posts,pages_show_list,business_management,pages_manage_metadata,pages_read_engagement`;
        openWindow(['Facebook'].includes(socialMedia) ? facebookUrl : instagramURL, "_blank", "width=650,height=700");
    };

    const handleGoogleAuthFlow = (type?) => {
        const request = async () => {
            let authResponse: object | any = {};
            if (['Google Business'].includes(type)) {
                authResponse = await httpclient().post(`/comm/googleBusiness/auth`);
            } else if (['Youtube'].includes(selectedSocialMedia?.NAME)) {
                authResponse = await httpclient().post(`/comm/youtube/auth`);
            }
            const authUrl = getGoogleAuthUrl(authResponse?.data?.data?.auth_url);
            if ((window.focus as any) && authUrl) { openWindow(authUrl, "google auth", 'width=600,height=400'); }
        };
        request();
    };

    const connect = () => {
        if (['Facebook', 'Instagram'].includes(selectedSocialMedia?.NAME)) {
            openPopUp(selectedSocialMedia?.NAME);
        } else if (['Google Business', 'Youtube'].includes(selectedSocialMedia?.NAME)) {
            handleGoogleAuthFlow(selectedSocialMedia?.NAME);
        } else if (['WhatsApp Business'].includes(selectedSocialMedia?.NAME)) {
            handleWhatsAppAuthFlow();
        }
    };

    return {
        connect,
        whatsAppSession
    };
};
